import { Tabs } from 'antd';
import { KeyRound } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { PageHeader } from '../../components/ui/index.js';
import { AccessAssignmentsPanel } from './AccessAssignmentsPanel.js';
import { AccessPositionsPanel } from './AccessPositionsPanel.js';
import { AccessRequestsPanel } from './AccessRequestsPanel.js';
import { AccessRoleCatalogPanel } from './AccessRoleCatalogPanel.js';
import { PlatformPermissionsPage } from './PlatformPermissionsPage.js';

export function AccessCenterPage() {
  const { t } = useTranslation('accessCenter');
  const [params, setParams] = useSearchParams();
  const activeKey = params.get('tab') ?? 'platform-roles';
  return (
    <div>
      <PageHeader title={t('title')} subtitle={t('subtitle')} icon={<KeyRound size={20} />} />
      <Tabs
        activeKey={activeKey}
        onChange={(tab) => setParams({ tab })}
        items={[
          {
            key: 'platform-roles',
            label: t('platformRoles'),
            children: <PlatformPermissionsPage embedded />,
          },
          { key: 'positions', label: t('positions'), children: <AccessPositionsPanel /> },
          { key: 'roles', label: t('roleCatalog'), children: <AccessRoleCatalogPanel /> },
          { key: 'assignments', label: t('assignments'), children: <AccessAssignmentsPanel /> },
          { key: 'requests', label: t('requests'), children: <AccessRequestsPanel /> },
        ]}
      />
    </div>
  );
}
